import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompaniesRoutingModule } from './companies-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { CompaniesComponent } from './companies/companies.component';
import { CompaniesContractDialogComponent } from './companies-contract-dialog/companies-contract-dialog.component';
import { CompaniesHeaderComponent } from './companies-header/companies-header.component';
import { CompaniesSummaryComponent } from './companies-summary/companies-summary.component';
import { CompaniesDataComponent } from './companies-data/companies-data.component';
import { CompaniesDataEmptyComponent } from './companies-data-empty/companies-data-empty.component';
import { CompaniesDataTableComponent } from './companies-data-table/companies-data-table.component';
import { CompaniesFilterDialogComponent } from './companies-filter-dialog/companies-filter-dialog.component';
import { CompaniesFiltersComponent } from './companies-filters/companies-filters.component';
import { CompaniesPaymentMethodsDialogComponent } from './companies-payment-methods-dialog/companies-payment-methods-dialog.component';
import { CompaniesArchiveDialogComponent } from './companies-archive-dialog/companies-archive-dialog.component';
import { CompaniesEditDialogComponent } from './companies-edit-dialog/companies-edit-dialog.component';
import { CompaniesSalesNetworkDialogComponent } from './companies-sales-network-dialog/companies-sales-network-dialog.component';
import { CompaniesSettingsDialogComponent } from './companies-settings-dialog/companies-settings-dialog.component';
import { CompaniesSubdomainDialogComponent } from './companies-subdomain-dialog/companies-subdomain-dialog.component';
import { CompaniesProductCategoryDialogComponent } from './companies-product-category-dialog/companies-product-category-dialog.component';
import { CompaniesAllowedStepsDialogComponent } from './companies-allowed-steps-dialog/companies-allowed-steps-dialog.component';
import { CompaniesTicketDialogComponent } from './companies-ticket-dialog/companies-ticket-dialog.component';
import { CompaniesOriginDialogComponent } from './companies-origin-dialog/companies-origin-dialog.component';
import { CompaniesArchivedNoteDialogComponent } from './companies-archived-note-dialog/companies-archived-note-dialog.component';
import { CompaniesAgreementDialogComponent } from './companies-agreement-dialog/companies-agreement-dialog.component';
import { CompaniesToggleDialogComponent } from './companies-toggle-dialog/companies-toggle-dialog.component';
import { CompaniesSalesReferenceEmailDialogComponent } from './companies-sales-reference-email-dialog/companies-sales-reference-email-dialog.component';
import { CompaniesNotesDialogComponent } from './companies-notes-dialog/companies-notes-dialog.component';

@NgModule({
  declarations: [
    CompaniesComponent,
    CompaniesContractDialogComponent,
    CompaniesHeaderComponent,
    CompaniesSummaryComponent,
    CompaniesDataComponent,
    CompaniesDataEmptyComponent,
    CompaniesDataTableComponent,
    CompaniesFilterDialogComponent,
    CompaniesFiltersComponent,
    CompaniesPaymentMethodsDialogComponent,
    CompaniesArchiveDialogComponent,
    CompaniesEditDialogComponent,
    CompaniesSalesNetworkDialogComponent,
    CompaniesSettingsDialogComponent,
    CompaniesSubdomainDialogComponent,
    CompaniesProductCategoryDialogComponent,
    CompaniesAllowedStepsDialogComponent,
    CompaniesTicketDialogComponent,
    CompaniesOriginDialogComponent,
    CompaniesArchivedNoteDialogComponent,
    CompaniesAgreementDialogComponent,
    CompaniesToggleDialogComponent,
    CompaniesSalesReferenceEmailDialogComponent,
    CompaniesNotesDialogComponent,
  ],
  imports: [
    CommonModule,
    CompaniesRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatMenuModule,
  ],
  exports: [CompaniesContractDialogComponent],
})
export class CompaniesModule {}
